import React from "react";

// Import your icons
import perfect_match from "../Assets/images/perfect_match.png";
import Vision from "../Assets/images/Vision.png";
import Collaborate from "../Assets/images/Collaborate.png";
import Review from "../Assets/images/Review.png";
import Celebrate from "../Assets/images/Celebrate.png";
import Icon6 from "../Assets/images/icon6.png";

function IrregularShapesSection() {
  const shapeData = [
    {
      title: "Perfect Match",
      description: "Brands, meet your dream team of content creators. Creators, find your ideal brand partners.",
      icon: perfect_match,
      shapeClass: "shape-1",
      color: "#3B82F6", // Blue
      lightColor: "#EFF6FF",
    },
    {
      title: "Vision",
      description: "Once you've found your match, it's time to bring your vision to life.",
      icon: Vision,
      shapeClass: "shape-2",
      color: "#F59E0B", // Amber
      lightColor: "#FFFBEB",
    },
    {
      title: "Collaborate Seamlessly",
      description: "Say goodbye to endless emails and missed deadlines.",
      icon: Collaborate,
      shapeClass: "shape-3",
      color: "#10B981", // Emerald
      lightColor: "#ECFDF5",
    },
    {
      title: "Review & Revise",
      description: "Real-time insights into performance metrics, audience engagement, and more.",
      icon: Review,
      shapeClass: "shape-4",
      color: "#8B5CF6", // Violet
      lightColor: "#F5F3FF",
    },
    {
      title: "Celebrate Success",
      description: "Celebrate every milestone, big or small.",
      icon: Celebrate,
      shapeClass: "shape-5",
      color: "#EC4899", // Pink
      lightColor: "#FDF2F8",
    },
    {
      title: "Voila!",
      description: "It's that easy to collaborate and create content that skyrockets your brand.",
      icon: Icon6,
      shapeClass: "shape-6",
      color: "#06B6D4", // Cyan
      lightColor: "#ECFEFF",
    },
  ];

  return (
    <div className="py-20 md:py-32 relative overflow-hidden bg-white">
      {/* Background Micro-elements */}
      <div className="absolute top-20 left-10 w-4 h-4 rounded-full bg-blue-200/50 animate-float-slow"></div>
      <div className="absolute bottom-40 right-20 w-6 h-6 rounded-full bg-purple-200/50 animate-float-mid"></div>
      <div className="absolute top-1/2 left-1/2 w-8 h-8 rounded-full bg-orange-200/30 animate-float-fast"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16 md:mb-24 max-w-3xl mx-auto px-4">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-indigo-50 text-indigo-700 rounded-full text-xs font-black mb-6 md:mb-8 border border-indigo-100/50 shadow-sm uppercase tracking-widest animate-bounce-subtle">
            <span className="text-base">🚀</span> Our Process
          </div>
          <h2 className="text-3xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-gray-800 to-gray-600 mb-6 md:mb-8 tracking-tighter leading-tight">
            Our Unique Features
          </h2>
          <p className="text-gray-500 text-lg md:text-xl font-medium leading-relaxed">
            A seamless journey from finding your perfect match to celebrating your viral success.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 md:gap-x-16 gap-y-20 md:gap-y-28 px-2 lg:px-12 justify-items-center">
          {shapeData.map((shape, index) => (
            <div key={index} className="group relative flex flex-col items-center text-center max-w-sm transition-all duration-500 hover:-translate-y-4">
              {/* Step Number Decorative */}
              <div 
                className="absolute -top-12 left-1/2 -translate-x-1/2 text-9xl font-black opacity-10 -z-10 select-none transition-all duration-500 group-hover:scale-125 group-hover:opacity-20"
                style={{ color: shape.color }}
              >
                {String(index + 1).padStart(2, '0')}
              </div>
              
              <div className="relative mb-12">
                <div
                  className={`irregular-shape flex items-center justify-center text-4xl shadow-xl transition-all duration-700 group-hover:shadow-[0_20px_60px_-15px_rgba(0,0,0,0.2)] animate-float-${index % 3 === 0 ? 'slow' : index % 3 === 1 ? 'mid' : 'fast'} ${shape.shapeClass}`}
                  style={{ backgroundColor: shape.color }}
                >
                  <img src={shape.icon} alt={shape.title} className="w-12 h-12 brightness-0 invert drop-shadow-md transition-all duration-500 group-hover:scale-125 group-hover:rotate-12" />
                </div>
                {/* Decorative Dots around shape */}
                <div className="absolute -top-2 -right-2 w-4 h-4 rounded-full opacity-40 animate-pulse" style={{ backgroundColor: shape.color }}></div>
                <div className="absolute -bottom-4 -left-3 w-3 h-3 rounded-full opacity-30 animate-pulse" style={{ backgroundColor: shape.color, animationDelay: '1s' }}></div>
              </div>
              
              <h3 
                className="text-2xl font-black mb-6 transition-all duration-300 group-hover:scale-105"
                style={{ color: shape.color }}
              >
                {shape.title}
              </h3>
              <p className="text-gray-500 text-lg leading-relaxed font-semibold px-4">
                {shape.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .irregular-shape {
          width: 120px;
          height: 120px;
        }

        .shape-1 { border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; }
        .shape-2 { border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%; }
        .shape-3 { border-radius: 50% 50% 20% 80% / 25% 80% 20% 75%; }
        .shape-4 { border-radius: 77% 23% 74% 26% / 24% 82% 18% 76%; }
        .shape-5 { border-radius: 25% 75% 17% 83% / 78% 30% 70% 22%; }
        .shape-6 { border-radius: 40% 60% 55% 45% / 45% 45% 55% 55%; }

        @keyframes float-slow {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }
        @keyframes float-mid {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(-3deg); }
        }
        @keyframes float-fast {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-10px) rotate(2deg); }
        }
        @keyframes bounce-subtle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }

        .animate-float-slow { animation: float-slow 6s ease-in-out infinite; }
        .animate-float-mid { animation: float-mid 5s ease-in-out infinite; }
        .animate-float-fast { animation: float-fast 4s ease-in-out infinite; }
        .animate-bounce-subtle { animation: bounce-subtle 3s ease-in-out infinite; }

        .group:hover .irregular-shape {
          border-radius: 50% !important;
          transform: scale(1.1) rotate(0deg) !important;
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}

export default IrregularShapesSection;
